<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ title | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
    <p [innerHTML]="'DUPLICATE_WITHDRAWL_APPEAL_TEXT_01' | globalTranslate"></p>
    <p [innerHTML]="'DUPLICATE_WITHDRAWL_APPEAL_TEXT_02' | globalTranslate"></p>
  </div>
  <div class="modal-footer">
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn d-grid btn-secondary" (click)="onAppealConfirm()">{{
        'Withdraw' | globalTranslate }}</button>
    </div>
    <div class="me-2 ml-2">
      <button type="button" id="dialog" class="btn d-grid btn-link" (click)="onCancel()">{{ 'EXIT' | globalTranslate
        }}</button>
    </div>
  </div>
</div>